import React, { useEffect } from 'react';
import { trans } from '../../../_providers/Translation'

function Contractor(props) {

    return (
        <table>
            <thead>
                <tr>
                    <th>{trans('tables.activity')}</th>
                    <th>{trans('tables.date')}</th>
                    <th>{trans('tables.employee')}</th>
    
                    <th>{trans('tables.type')}</th>
                    <th>{trans('tables.name')}</th>
                    <th>{trans('tables.eik')}</th>
                    <th>{trans('tables.vat_number')}</th>
                    <th>{trans('tables.mol')}</th>
                    <th>{trans('tables.address')}</th>
                    <th>{trans('tables.postCode')}</th>
                    <th>{trans('tables.phone')}</th>
                    <th>{trans('tables.email')}</th>
                    <th>{trans('tables.accounting_email')}</th>
                    <th>{trans('tables.active')}</th>
                    <th>{trans('tables.charge')}</th>
                    <th>{trans('tables.send_reports')}</th>
                    <th>{trans('tables.repair_warranty')}</th>
                    <th>{trans('tables.labour_price_type_id')}</th>
                    <th>{trans('tables.payment_terms')}</th>
                </tr>
            </thead>
            <tbody>
                {props.data.map((h, i) => (
                    <tr key={i} className={[h.actual ? 'actual' : h.selected ? 'selected' : '']}>
                            <td>{h.event}</td>
                            <td>{h.date}</td>
                            <td>{h.causer ? `${h.causer.name} ${h.causer.lastname}` : '-'}</td>
                       
                            <td>{h.subject?.type?.name ?? '-'}</td>
                            <td>{h.subject?.name ?? '-'}</td>
                            <td>{h.subject?.eik ?? '-'}</td>
                            <td>{h.subject?.vat_number ?? '-'}</td>
                            <td>{h.subject?.mol ?? '-'}</td>
                            <td>{h.subject?.address ?? '-'}</td>
                            <td>{h.subject?.postcode ?? '-'}</td>
                            <td>{h.subject?.phone ?? '-'}</td>
                            <td>{h.subject?.email ?? '-'}</td>
                            <td>{h.subject?.accounting_email ?? '-'}</td>
                            <td>{h.subject?.active ? trans('tables.yes') : trans('tables.no')}</td>
                            <td>{h.subject?.charge ? trans('tables.yes') : trans('tables.no')}</td>
                            <td>{h.subject?.send_reports ? trans('tables.yes') : trans('tables.no')}</td>
                            <td>{h.subject?.repair_warranty ?? '-'}</td>
                            <td>{h.subject?.labour_price_type?.name ?? '-'}</td>
                            <td>{h.subject?.payment_terms ?? '-'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default Contractor;
